import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboardService';

export function useDashboardMetrics(startDate: string, endDate: string, hasCompany: boolean = true) {
  return useQuery({
    queryKey: ['dashboard-metrics', startDate, endDate],
    queryFn: () => dashboardService.getMetrics(startDate, endDate),
    enabled: hasCompany && Boolean(startDate && endDate),
  });
}

export function useDashboardCharts(monthsBack: number = 6, hasCompany: boolean = true) {
  return useQuery({
    queryKey: ['dashboard-charts', monthsBack],
    queryFn: () => dashboardService.getCharts(monthsBack),
    enabled: hasCompany,
  });
}

export function useDashboardRankings(topN: number = 5, hasCompany: boolean = true) {
  return useQuery({
    queryKey: ['dashboard-rankings', topN],
    queryFn: () => dashboardService.getRankings(topN),
    enabled: hasCompany,
  });
}
